import { RemoteGetPendingActivitiesPerProfessionalSummary } from 'data/usecases';
import { GetPendingActivitiesPerProfessionalSummaryUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPendingActivitiesByProfessionalsSummary } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetPendingActivitiesPerProfessionalSummary =
  (): GetPendingActivitiesPerProfessionalSummaryUseCaseInterface =>
    new RemoteGetPendingActivitiesPerProfessionalSummary(
      makeApiUrlPendingActivitiesByProfessionalsSummary(),
      makeAxiosHttpClient(),
    );
